/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { useCallback, useState } from 'react';

export function useExpander(defaultExpanded = false) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleToggle = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded, setExpanded]);

  return { expanded, collapsed: !expanded, setExpanded, handleToggle };
}
